import AddRoundedIcon from "@mui/icons-material/AddRounded";
import HistoryRoundedIcon from "@mui/icons-material/HistoryRounded";
import { Box, Button, Typography } from "@mui/material";

import { useTranslation } from "@/translations";

interface Props {
  onHistoryClick: () => void;
  onNewRequestClick: () => void;
}

export function ExchangeHeader({ onHistoryClick, onNewRequestClick }: Props) {
  const { t } = useTranslation();

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
      <Typography variant="h1">{t("exchange.title")}</Typography>
      <Box display="flex" alignItems="center" gap={1}>
        <Button variant="outlined" startIcon={<HistoryRoundedIcon />} onClick={onHistoryClick}>
          {t("exchange.buttons.history")}
        </Button>
        <Button variant="contained" startIcon={<AddRoundedIcon />} onClick={onNewRequestClick}>
          {t("exchange.buttons.newRequest")}
        </Button>
      </Box>
    </Box>
  );
}
